import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Package,
  FolderOpen,
  FileText,
  Image,
  Award,
  Settings,
  MessageSquare,
  Mail,
  SlidersHorizontal,
  Filter,
  Search,
  MapPin,
  Database,
  Star,
  Building2,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const navGroups = [
  {
    label: null,
    items: [
      { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
    ],
  },
  {
    label: 'Content Management',
    items: [
      { to: '/admin/products', icon: Package, label: 'Products' },
      { to: '/admin/categories', icon: FolderOpen, label: 'Categories' },
      { to: '/admin/filters', icon: Filter, label: 'Filters' },
      { to: '/admin/configurator-templates', icon: SlidersHorizontal, label: 'Configurators' },
      { to: '/admin/gallery', icon: Image, label: 'Gallery' },
      { to: '/admin/certificates', icon: Award, label: 'Certificates' },
      { to: '/admin/seo', icon: Search, label: 'SEO' },
      { to: '/admin/settings', icon: Settings, label: 'Settings' },
    ],
  },
  {
    label: 'Sales & CRM',
    items: [
      { to: '/admin/leads', icon: MapPin, label: 'Sales Leads' },
      { to: '/admin/shortlist', icon: Star, label: 'Shortlist' },
      { to: '/admin/quotes', icon: FileText, label: 'Quote Requests' },
      { to: '/admin/subscribers', icon: Mail, label: 'Subscribers' },
      { to: '/admin/messages', icon: MessageSquare, label: 'Messages' },
      { to: '/admin/factory-info', icon: Building2, label: 'Factory Info' },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/admin/lead-stats', icon: Database, label: 'Lead Statistics' },
    ],
  },
]

export function AdminSidebar() {
  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-secondary-900 text-white hidden lg:flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-secondary-800">
        <a href="/" className="block">
          <img
            src="/images/logo-white.png"
            alt="EngiMarineX"
            className="h-16 w-auto object-contain"
          />
          <span className="text-xs text-secondary-400 mt-2 block">Admin Panel</span>
        </a>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-6 overflow-y-auto">
        {navGroups.map((group, groupIndex) => (
          <div key={groupIndex}>
            {group.label && (
              <p className="text-xs text-secondary-500 uppercase tracking-wider mb-2 px-4">
                {group.label}
              </p>
            )}
            <div className="space-y-1">
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={'end' in item ? item.end : undefined}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary-600 text-white'
                        : 'text-secondary-300 hover:bg-secondary-800 hover:text-white'
                    )
                  }
                >
                  <item.icon className="w-5 h-5" />
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  )
}
